import { isPdf, ResponsivePdfViewer } from "@/components/ui/responsive-pdf-viewer";

import { Button, buttonVariants } from "@/components/ui/button";

export interface LocalInboxPreview {
  url: string;
  mimeType: string;
}

/** The page owns the URL lifetime; opening or closing this panel never fetches a file. */
export function InboxUploadPreview({ name, preview, canUndo, undoing, onUndo, onClose }: {
  name: string;
  preview: LocalInboxPreview;
  canUndo: boolean;
  undoing: boolean;
  onUndo: () => void;
  onClose: () => void;
}) {
  return <section aria-label="Pregled dokumenta" className="avm-surface flex min-w-0 flex-col rounded-[var(--radius-card)] border border-border bg-card p-4 md:p-6 lg:sticky lg:top-0 lg:h-full lg:min-h-0">
    <div className="mb-4 flex shrink-0 flex-wrap items-center justify-between gap-3">
      <h2 className="min-w-0 break-all font-semibold">Pregled: {name}</h2>
      <div className="flex flex-wrap gap-2">
        {canUndo && <Button type="button" variant="outline" disabled={undoing} onClick={onUndo}>{undoing ? "Poništavam…" : "Poništi"}</Button>}
        <Button type="button" variant="outline" onClick={onClose}>Zatvori pregled</Button>
      </div>
    </div>
    <div className="min-h-0 lg:flex lg:flex-1 lg:flex-col lg:overflow-auto">
    {isPdf(preview.mimeType)
      ? <><a href={preview.url} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center underline lg:hidden">Otvori PDF</a><a href={preview.url} download={name} className={buttonVariants({ variant: "secondary", size: "sm" })}>Preuzmi</a><ResponsivePdfViewer url={preview.url} title={`Pregled PDF-a: ${name}`} filename={name} iframeClassName="h-[70vh] min-h-0 w-full rounded border border-border lg:h-full lg:flex-1" mobileClassName="h-[70dvh] rounded border border-border" /></>
      : <img src={preview.url} alt={`Pregled: ${name}`} className="mx-auto max-h-[70vh] max-w-full rounded object-contain lg:min-h-0 lg:max-h-full lg:flex-1" />}
    </div>
  </section>;
}
